import {useEffect, useState} from "react";
import httpService from "../services/httpService"; // your axios wrapper
import { useNavigate, Link } from "react-router-dom";
import posthog from 'posthog-js';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Image from 'react-bootstrap/Image';

import { useAuthStore } from '../store/store';
import SsoComponent from "../components/SsoComponent";
import Alert from 'react-bootstrap/Alert';
import {FaArrowRightFromBracket, FaSpinner} from "react-icons/fa6";
import AnimatedImage from "../components/AnimatedImage";
import {makeSignupData} from "../utils/dummyDataGenrators";

const SignUpForm = () => {
    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        password_confirmation: "",
    });

    useEffect(() => {
        if(process.env.NODE_ENV === 'development'){
            setFormData(makeSignupData());
        }
    }, []);

    const [errors, setErrors] = useState({
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        password_confirmation: "",
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const setToken = useAuthStore(state => state.setToken);
    const setUser = useAuthStore(state => state.setUser);
    const [errorMessage, setErrorMessage] = useState('');
    const [signupClub, setSignupClub] = useState(null);

    useEffect(() => {
        const raw = sessionStorage.getItem("signup_club");
        if (raw) {
            try { setSignupClub(JSON.parse(raw)); } catch { /* ignore */ }
        }
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        try {
            const signup_token = sessionStorage.getItem("signup_token");
            const payload = signup_token ? { ...formData, signup_token } : formData;
            const res = await httpService.post("register", payload);
            // const res = {
            //     data : {
            //         "message": "User registered",
            //         "user_info": {
            //             "first_name": "Taylor",
            //             "avatar_url": null,
            //             "user_id": 5
            //         },
            //         "token": "5|wbeRoCjLSvXlcloN9FNYuQhj8qesPGGL7bANS0p3ead1b6e7"
            //     }
            // }
            setToken(res.data.token)
            setUser(res.data.user)
            posthog.identify(String(res.data.user.user_id), {
                email: formData.email,
                name: formData.first_name,
                $set_once: { signup_date: new Date().toISOString() },
            });
            posthog.capture('user_signed_up', {
                flow: res.data.flow,
                via_invite: !!sessionStorage.getItem("signup_token"),
            });

            const storedClub = sessionStorage.getItem("signup_club");
            sessionStorage.removeItem("signup_token");
            sessionStorage.removeItem("signup_club");

            if (storedClub && res.data.flow === 'register_demographics') {
                // Invite code flow — auto-register as listener and go straight to the club
                let clubGuid = null;
                try { clubGuid = JSON.parse(storedClub).guid; } catch { /* ignore */ }
                await httpService.post("dash/register-demographics", { role: 'listener' });
                navigate(clubGuid ? `/listener-podcast-club/${clubGuid}` : '/listener-clubs');
            } else if(res.data.flow === 'register_demographics'){
                navigate("/register");
            } else if(res.data.flow === 'something_else'){
                navigate("/dashboard");
            } else {
                alert('wrong flow ...')
            }
            setErrorMessage('')
        } catch (err) {
            console.error("Signup error message:", err.response.data.message);
            console.error("Signup errors:", err.response.data.errors);
            posthog.captureException(err, { tags: { context: 'signup' } });
            setErrorMessage(err.message)
            setErrors(err.response.data.errors)
            setLoading(false)
        } finally {

        }
    };

    return (
        <Container className="d-flex justify-content-center align-items-center py-5">
            <Row className="w-100 justify-content-center">
                <Col xs={12} sm={10} md={8} lg={6} xl={5}>
                    <Card style={{ overflow: 'hidden' }}>
                        <Row className="g-0">
                            <Col>
                                <div className='p-3'>
                                    <div className={'position-absolute'}>
                                        <Link to="/"><FaArrowRightFromBracket /></Link>
                                    </div>
                                    <div className={'text-center'}>
                                        <AnimatedImage
                                            src="/img/podsy-logo-w-200.png"
                                            alt="Podsy Logo"
                                            loopMs={3000}      // speed of the float loop
                                            aberration={true}  // toggle chromatic aberration
                                            className="" // your sizing classes
                                        />
                                        {/*<Image src="/img/podsy-logo-w-500.png" fluid className={"w-75"} />*/}
                                    </div>
                                    {signupClub && (
                                        <Alert variant="info" className="mb-3 small">
                                            You're signing up to join <strong>{signupClub.title}</strong>. You'll be added to the club after completing registration.
                                        </Alert>
                                    )}
                                    <Form className='text-left' onSubmit={handleSubmit}>
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-2" controlId="first_name">
                                                    <Form.Label>First name</Form.Label>
                                                    <Form.Control
                                                        name={'first_name'}
                                                        type="text"
                                                        disabled={loading}
                                                        placeholder="First name"
                                                        value={formData.first_name}
                                                        onChange={handleChange}
                                                        isInvalid={!!errors.first_name}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.first_name?.[0]}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-2" controlId="LastName">
                                                    <Form.Label>Last name</Form.Label>
                                                    <Form.Control
                                                        name={'last_name'}
                                                        type="text"
                                                        disabled={loading}
                                                        placeholder="Last name"
                                                        value={formData.last_name}
                                                        onChange={handleChange}
                                                        isInvalid={!!errors.last_name}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.last_name?.[0]}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Form.Group className="mb-2" controlId="Email">
                                            <Form.Label>Email address</Form.Label>
                                            <Form.Control
                                                name={'email'}
                                                type="email"
                                                disabled={loading}
                                                placeholder="Enter email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                isInvalid={!!errors.email}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.email?.[0]}
                                            </Form.Control.Feedback>
                                            {/*<Form.Text className="text-muted">*/}
                                            {/*    We'll never share your email with anyone else.*/}
                                            {/*</Form.Text>*/}
                                        </Form.Group>
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-2" controlId="Password">
                                                    <Form.Label>Password</Form.Label>
                                                    <Form.Control
                                                        name={'password'}
                                                        type="password"
                                                        disabled={loading}
                                                        placeholder="Password"
                                                        value={formData.password}
                                                        onChange={handleChange}
                                                        isInvalid={!!errors.password}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.password?.[0]}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-4" controlId="PasswordRepeat">
                                                    <Form.Label>Confirm password</Form.Label>
                                                    <Form.Control
                                                        name={'password_confirmation'}
                                                        type="password"
                                                        disabled={loading}
                                                        placeholder="Confirm password"
                                                        value={formData.password_confirmation}
                                                        onChange={handleChange}
                                                        isInvalid={!!errors.password_confirmation}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.password_confirmation?.[0]}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Button disabled={loading} className="w-100 mb-3" variant="light" type="submit">
                                            {loading ? <FaSpinner className={"loading_spinner"} /> : 'Sign Up'}
                                        </Button>
                                        <Row className={'mt-1 text-center'}>
                                            <Col><hr/></Col>
                                            <Col>
                                                or continue with
                                            </Col>
                                            <Col><hr/></Col>
                                        </Row>
                                    </Form>
                                    <SsoComponent />
                                    <Row className={'mt-3 text-center'}>
                                        <Col>
                                            You have an account ? <Link to="/login">login</Link>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default SignUpForm;
